import React from "react";
import "./TableWorker.styles.scss";
import { Link } from "react-router-dom";
import { Button } from "react-materialize";
import { Chip } from "@material-ui/core";

const tags = {
  peon: "Peon",
  office_manager: "Manager",
  security_guard: "Guard",
  cleaner: "Cleaner",
};

const TableWorker = ({ data }) => {
  const {
    image,
    name,
    employee_id,
    contact_number,
    reporting_agency__name,
    id,
    leave_day,
    is_active,
    type,
  } = data;

  return (
    <tr className="worker-row">
      <td className="worker-avatar-column">
        <div className="avatar-chip">
          {image ? (
            <img
              src={`${image}`}
              alt={`worker name ${name}`}
              className="worker-image"
            />
          ) : (
            <img
              src={`https://png.pngitem.com/pimgs/s/506-5067022_sweet-shap-profile-placeholder-hd-png-download.png`}
              alt={`worker name ${name}`}
              className="worker-image"
            />
          )}

          <p>{name}</p>
          {!is_active && (
            <p className="status-fse" style={{ paddingLeft: 2 }}>
              Deactivated
            </p>
          )}
          {type && <span className={`empolyee-tag`}>{tags[type]}</span>}
        </div>
      </td>

      <td className="emp-id">
        <span>{employee_id ? employee_id : ""}</span>
      </td>

      <td className="phone">
        <span>{contact_number}</span>
      </td>

      <td className="agency">
        <span>{reporting_agency__name}</span>
      </td>

      <td className="leave">
        <span>{leave_day}</span>
      </td>

      <td className="button-column">
        <div className="button-wrapper">
          {/* <Link to={`/task_assignment/${id}`}> */}
          <Link
            to={{
              pathname: `/admin/employee/${id}`,
              state: { data },
            }}
          >
            <Button className="button">Manage</Button>
          </Link>
        </div>
      </td>
    </tr>
  );
};

export default TableWorker;
